import { store } from '../../index'; // Adjust the path to your Redux store
import { logoutUser } from '../../Reducers/authActions'; // Import your logoutUser action


export function handleResponse(response) {
    return response.text().then(text => {
        if (!response.ok) {
            if ([401].indexOf(response.status) !== -1) {
                // auto logout if 403 Forbidden response returned from api
                store.dispatch(logoutUser());
            }
            return Promise.reject(response);
        }
        const data = text && JSON.parse(text);
        return data;
    });
}

// const logout = () => {
//     const auth = getAuth();

//     signOut(auth).then((response) => {
//         // actions.logout();

//         if (window.location.pathname.toLowerCase().includes('taplr.app')) {
//             window.location.replace('/taplr.app/login');
//         } else {
//             window.location.replace('/login');
//         }
//         // actions.setLogin(false);
//         // actions.setUserid(null);
//         // actions.setUserToken(null);

//         // Sign-out successful.
//     }).catch((error) => {
//         console.log(error, 'error')
//         // An error happened.
//     });
// }